import { useImperativeHandle, useRef } from "react";
import MapPropertiesService from '../services/MapPropertiesService';
import { EvaluationFeaturePolygon } from './polygons/EvaluationFeaturePolygon';
import { FairwayAreaFeaturePolygon } from './polygons/FairwayAreaFeaturePolygon';
import { MultiFeaturePolygon } from './polygons/MultiFeaturePolygon';
import { PcsFeaturePolygon } from './polygons/PcsFeaturePolygon';
import { PilotCertificateGroupAreaFeaturePolygon } from './polygons/PilotCertificateGroupAreaFeaturePolygon';
import { SegmentFeaturePolygon } from './polygons/SegmentFeaturePolygon';

interface MapPolygonRef {
    onSelect: (ids: number[]) => void
}

interface MapPolygonProps {
    ref?: React.Ref<MapPolygonRef>,
    source: any,
    mouseOverId?: number,
    focusId?: number,
    disabled?: boolean,
    onMouseOver?: (e: number) => void,
    onMouseOut?: () => void,
    onClick?: (e: any, f?:any) => void,
}

export const MapPolygon = ({
    ref,
    source,
    mouseOverId,
    focusId,
    disabled = false,
    onMouseOver,
    onMouseOut,
    onClick
}: MapPolygonProps) => {

    useImperativeHandle(ref, () => ({
        onSelect(ids: number[]) {
            pcsFeaturePolygonRef.current?.onSelect(ids);
        }
    }));

    const pcsFeaturePolygonRef: {current: any} = useRef(null);
    const mapProperties = MapPropertiesService.properties;
    
    return (
        (() => {
            switch (source.properties.featureType) {
                case mapProperties.PcsFeatureType:
                    return (<PcsFeaturePolygon
                        ref={pcsFeaturePolygonRef}
                        source={source}
                        disabled={disabled}
                        onClick={onClick}
                    />);
                case mapProperties.SegmentFeatureType:
                    return (<SegmentFeaturePolygon
                        source={source}
                        onMouseOver={onMouseOver}
                        onMouseOut={onMouseOut}
                        onClick={onClick}
                        mouseOverId={mouseOverId}
                        focusId={focusId}
                    />);
                case mapProperties.FairwayAreaFeatureType:
                    return <FairwayAreaFeaturePolygon source={source} />;
                case mapProperties.MultiFeatureType:
                    return <MultiFeaturePolygon source={source} />;
                case mapProperties.EvaluationFeatureType:
                    return <EvaluationFeaturePolygon source={source} />;
                case mapProperties.CertificateGroupAreaFeatureType:
                case mapProperties.AvailableFeatureType:
                    return <PilotCertificateGroupAreaFeaturePolygon source={source} />;
                default: return null;
            }
        })()
    );
}
